import {
	grayColor,
	whiteColor,
	blackColors,
	primaryColor,
	backgroundColor,
} from 'assets/jss/material-dashboard-pro-react';

const servicesTabStyle = (theme) => ({
	singleItem: {
		minHeight: 'auto !important',
		backgroundColor: grayColor[1],
		padding: '20px 30px',
		height: '64px',
		width: '100%',
		[theme.breakpoints.down('sm')]: {
			height: 'auto',
			padding: '20px 16px',
		},
		[theme.breakpoints.down('xs')]: {
			paddingLeft: 0,
			paddingRight: 0,
		},
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		'&:hover': {
			cursor: 'pointer',
		},
	},
	selectedSingleItem: {
		borderRadius: '8px',
		border: `2px solid ${primaryColor[0]}`,
	},
	packageName: {
		[theme.breakpoints.down('xs')]: {
			maxWidth: '70px',
		},
	},
	radioDescContainer: {
		width: '85%',
		display: 'flex',
		flexDirection: 'row',
		textAlign: 'left',
		alignItems: 'center',
		'& .MuiFormControlLabel-root': {
			paddingRight: 0,
			marginRight: 0,
		},
	},
	creditLimitContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'baseline',
	},
	radioLabel: {
		display: 'flex',
		flexDirection: 'row',
		minWidth: '400px',
		flexWrap: 'wrap',
		alignItems: 'center',
		[theme.breakpoints.down('md')]: {
			minWidth: '250px',
			width: '250px',
		},
		[theme.breakpoints.down('xs')]: {
			minWidth: '140px',
			width: '140px',
		},
	},
	shortDescription: {
		marginLeft: '100px',
		[theme.breakpoints.down('md')]: {
			marginLeft: '20px',
		},
		[theme.breakpoints.down('xs')]: {
			marginLeft: 0,
		},
	},
	priceContainer: {
		maxWidth: '70px',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'end',
		right: '40px',
		alignItems: 'center',
		[theme.breakpoints.down('sm')]: {
			maxWidth: '50px',
			right: '10px',
		},
		[theme.breakpoints.down('xs')]: {
			maxWidth: '38px',
		},
	},
	vatClauseWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: grayColor[2],
		padding: '0px 30px',
		height: 'auto',
		width: '100%',
		[theme.breakpoints.down('sm')]: {
			height: 'auto',
			padding: '20px 16px',
		},
		borderTop: '1px solid rgba(0, 0, 0, 0.06)',
	},
	termsAndConditionsWrapper: {
		display: 'flex',
		flexDirection: 'row',
	},
	servicesTabSummaryContainer: {
		marginTop: '40px',
		backgroundColor: whiteColor,
		borderRadius: '8px',
		padding: '20px',
	},
	summaryLine: {
		margin: '16px auto 16px',
		border: '1px solid rgba(0, 0, 0, 0.06)',
	},
	singleLine: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: '8px 0',
		width: '100%',
		alignItems: 'center',
		'& > div': {
			display: 'flex',
			alignItems: 'center',
			'& > p': {
				paddingRight: 8,
				minWidth: '100px',
				'&:last-of-type': {
					alignItems: 'center',
					paddingRight: 0,
				},
			},
		},
		[theme.breakpoints.down('xs')]: {
			'& > p': {
				textAlign: 'right',
				'&:last-of-type': {
					maxWidth: '50px',
				},
			},
		},
	},
	divider: {
		display: 'inline-flex',
		width: '45px',
		height: '0px',
		margin: '0 -8px',
		borderBottom: '1.6px solid rgba(0, 0, 0, 0.85)',
		transform: 'rotate(103.63deg)',
		position: 'relative',
	},
	servicesTab: {
		width: '100%',
		margin: '0 auto',
	},
	servicesTitleWrapper: {
		padding: '19px 0 8px 0',
	},
	expansionPanel: {
		boxShadow: 'none',
		'&:before': {
			display: 'none !important',
		},
		width: '100%',
		'&:hover': {
			backgroundColor: grayColor[3],
		},
	},
	expansionPanelExpanded: {
		margin: '0 !important',
	},
	expansionPanelSummary: {
		minHeight: 'auto !important',
		backgroundColor: 'transparent',
		margin: '2px 0',
		padding: '0 24px',
		height: '64px',
		width: '100%',
		transition: 'all .1s ease-in-out',
		'&.Mui-disabled': {
			opacity: 0.5,
		},
		[theme.breakpoints.down('sm')]: {
			height: 'auto',
			padding: '20px 16px',
		},
		'&:hover': {
			backgroundColor: grayColor[3],
		},
	},
	expansionPanelSummaryExpanded: {
		color: blackColors[0],
		'& $expansionPanelSummaryExpandIcon': {
			color: blackColors[0],
			[theme.breakpoints.up('md')]: {
				top: 'auto !important',
			},
			transform: 'rotate(-180deg)',
			[theme.breakpoints.down('sm')]: {
				top: '10px !important',
			},
		},
	},
	expansionPanelSummaryContent: {
		margin: '0 !important',
		alignItems: 'center',
		display: 'flex',
	},
	expansionPanelSummaryExpandIcon: {
		transform: 'rotate(0deg)',
		position: 'static',
		transition: 'all .3s ease-in-out',
		color: blackColors[0],
	},
	selectedPackCount: {
		position: 'absolute',
		right: '100px',
		color: primaryColor[0],
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		[theme.breakpoints.down('xs')]: {
			right: '30px',
			minWidth: '100px',
		},
	},
	selectedPackContainer: {
		position: 'absolute',
		right: '100px',
		color: primaryColor[0],
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		width: '290px',
		[theme.breakpoints.down('sm')]: {
			width: '200px',
			right: '50px',
		},
		[theme.breakpoints.down('xs')]: {
			right: '30px',
			width: '160px',
			minWidth: '160px',
		},
	},
	badge: {
		borderRadius: '4px',
		backgroundColor: primaryColor[0],
		width: '8px',
		height: '8px',
		top: '32px',
		marginRight: '8px',
	},
	selectedPackDescription: {
		[theme.breakpoints.down('sm')]: {
			maxWidth: '160px',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},
		[theme.breakpoints.down('xs')]: {
			maxWidth: '120px',
		},
	},
	expansionPanelDetails: {
		padding: 0,
		width: '100%',
		'& > div': {
			width: '100%',
		},
	},
	expansionSubpanelContainer: {
		width: '100%',
	},
	expansionSubpanelCircularProgress: {
		marginLeft: '20px',
	},
	expansionSubpanelSummary: {
		minHeight: 'auto !important',
		backgroundColor: grayColor[3],
		padding: '0 24px',
		height: '64px',
		width: '100%',
		transition: 'all .1s ease-in-out',
		'&.Mui-disabled': {
			opacity: 0.5,
		},
		[theme.breakpoints.down('sm')]: {
			height: 'auto',
			padding: '20px 16px',
		},
		[theme.breakpoints.down('xs')]: {
			padding: '20px 10px',
		},
		borderTop: '1px solid ' + backgroundColor,
		borderBottom: '1px solid ' + backgroundColor,
	},
	expansionPanelSubItems: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		borderBottom: '1px solid rgba(0, 0, 0, 0.38)',
	},
	expansionPanelHidden: {
		display: 'none',
	},
	mainExtensionPanelWrapper: {
		display: 'none',
	},
	priceWithoutVatWrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		justifyContent: 'center',
		'& > p:first-of-type': {
			lineHeight: '27px',
		},
	},

	totalAmountWrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start !important',
	},
});

export default servicesTabStyle;
